import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { CheckCircle2Icon } from 'lucide-react';
export function SolutionSection() {
  const features = ['+140 ejercicios analizados', 'Checklists de ejecución', 'Ilustraciones anatómicas', 'Con 2 bonos incluidos'];
  return <section className="py-14 bg-card-dark" data-id="element-309">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-310">
        <FadeIn className="text-center mb-10" data-id="element-311">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-white font-heading mb-2" data-id="element-312">
            Esto es lo que abrís
          </h2>
          <h3 className="text-4xl md:text-5xl lg:text-6xl font-black text-primary font-heading mb-4" data-id="element-313">
            en menos de una hora.
          </h3>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-314">
            Un vistazo al material que vas a tener en tus manos hoy.
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-6 mb-10" data-id="element-315">
          <FadeIn delay={0.3} direction="up" data-id="element-316">
            <div className="bg-background-dark border border-card-border-dark rounded-2xl p-4 h-full flex flex-col shadow-xl" data-id="element-317">
              <div className="rounded-xl overflow-hidden mb-4 bg-white/5 aspect-[3/4] relative" data-id="element-318">
                <img src="https://cdn.magicpatterns.com/uploads/12dfvJBiBooEECfefJRVyG/heylloyd-image-1772660592396.png" alt="Análisis técnico por ejercicio" className="w-full h-full object-contain p-2" data-id="element-319" />
              </div>
              <div className="flex items-center gap-3 mt-auto" data-id="element-320">
                <CheckCircle2Icon className="w-6 h-6 text-success shrink-0" data-id="element-321" />
                <p className="text-white font-bold text-sm md:text-base" data-id="element-322">
                  Análisis técnico por ejercicio
                </p>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.4} direction="up" data-id="element-323">
            <div className="bg-background-dark border border-card-border-dark rounded-2xl p-4 h-full flex flex-col shadow-xl" data-id="element-324">
              <div className="rounded-xl overflow-hidden mb-4 bg-white/5 aspect-[3/4] relative" data-id="element-325">
                <img src="https://cdn.magicpatterns.com/uploads/oK4LNtxptYf9gUiWwaN3Ad/heylloyd-image-1772660520858.png" alt="Ilustraciones anatómicas reales" className="w-full h-full object-contain p-2" data-id="element-326" />
              </div>
              <div className="flex items-center gap-3 mt-auto" data-id="element-327">
                <CheckCircle2Icon className="w-6 h-6 text-success shrink-0" data-id="element-328" />
                <p className="text-white font-bold text-sm md:text-base" data-id="element-329">
                  Ilustraciones anatómicas reales
                </p>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.5} direction="up" data-id="element-330">
            <div className="bg-background-dark border border-card-border-dark rounded-2xl p-4 h-full flex flex-col shadow-xl" data-id="element-331">
              <div className="rounded-xl overflow-hidden mb-4 bg-white/5 aspect-[3/4] relative" data-id="element-332">
                <img src="https://cdn.magicpatterns.com/uploads/2LBbvNnt9k9k9FpNLmvZJi/heylloyd-image-1772660266126.png" alt="Base científica aplicada" className="w-full h-full object-contain p-2" data-id="element-333" />
              </div>
              <div className="flex items-center gap-3 mt-auto" data-id="element-334">
                <CheckCircle2Icon className="w-6 h-6 text-success shrink-0" data-id="element-335" />
                <p className="text-white font-bold text-sm md:text-base" data-id="element-336">
                  Base científica aplicada
                </p>
              </div>
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={0.6} data-id="element-337">
          <div className="bg-background-dark rounded-2xl p-6 border border-card-border-dark" data-id="element-338">
            <div className="flex flex-wrap items-center justify-center gap-4 md:gap-8" data-id="element-339">
              {features.map((feature, index) => <div key={index} className="flex items-center gap-2" data-id="element-340">
                  <CheckCircle2Icon className="w-5 h-5 text-success shrink-0" data-id="element-341" />
                  <span className="text-white font-medium text-sm md:text-base" data-id="element-342">
                    {feature}
                  </span>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}